import React from 'react';
import { Book, Calendar, FileCheck, ShieldCheck, FileText } from 'lucide-react';
export function SystemIncludesSection() {
  const items = [{
    icon: Book,
    text: 'Manual para Padres (Paso a paso)'
  }, {
    icon: Calendar,
    text: 'Plan de Acción de 21 Días'
  }, {
    icon: FileText,
    text: 'Workbook imprimible de actividades'
  }, {
    icon: FileCheck,
    text: 'Checklist de progreso diario'
  }, {
    icon: ShieldCheck,
    text: 'Guía Anti Frustración'
  }];
  return <section className="py-20 px-4 bg-[#F5F1EA]" data-id="element-139">
      <div className="max-w-5xl mx-auto" data-id="element-140">
        <div className="text-center mb-12" data-id="element-141">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2D3648] mb-8" data-id="element-142">
            Recibís el sistema completo
          </h2>

          <div className="flex flex-wrap justify-center gap-4 mb-16" data-id="element-143">
            {items.map((item, index) => <div key={index} className="flex items-center bg-white px-4 py-3 rounded-lg shadow-sm border border-[#5C6B60]/10" data-id="element-144">
                <item.icon className="w-5 h-5 text-[#C2644C] mr-3" data-id="element-145" />
                <span className="text-[#4A5568] font-medium" data-id="element-146">{item.text}</span>
              </div>)}
          </div>
        </div>

        {/* Mockup Image */}
        <div className="max-w-lg mx-auto relative" data-id="element-147">
          <div className="aspect-[4/5] rounded-2xl overflow-hidden shadow-2xl ring-1 ring-black/5 transform hover:scale-[1.02] transition-transform duration-500" data-id="element-148">
            <img src="https://cdn.magicpatterns.com/uploads/jYN4jTByAvhjNqJwu8Hdri/mockup_verdadero_2.png" alt="Mockup del sistema educativo premium en escritorio de madera" className="w-full h-full object-cover" data-id="element-149" />
          </div>
          {/* Shadow effect */}
          <div className="absolute -bottom-8 left-1/2 -translate-x-1/2 w-[80%] h-8 bg-black/20 blur-xl rounded-full" data-id="element-150" />
        </div>
      </div>
    </section>;
}